const realizations = {
	trigger: document.querySelectorAll(
		'.block-realizations__list-header-button',
	),

	init() {
		if ( this.trigger.length > 0 ) {
			[ ...this.trigger ].forEach( ( tab ) => {
				tab.addEventListener( 'click', ( e ) => this.toggleTab( e ) );
			} );
		}
	},
	toggleTab( e ) {
		e.preventDefault();
		const dataId = e.currentTarget.dataset.id;
		const parent = e.currentTarget.closest( '.block-realizations__list' );
		const wrapper = parent.querySelector(
			'.block-realizations__list-galleries',
		);
		const tabContents = parent.querySelectorAll(
			'.block-realizations__list-galleries-item',
		);
		const tabContent = wrapper.querySelector( `[data-id="${ dataId }"]` );
		const items = parent.querySelectorAll(
			'.block-realizations__list-header-button',
		);

		items.forEach( ( item ) => {
			if (
				item.classList.contains(
					'block-realizations__list-header-button--active',
				)
			) {
				item.classList.remove(
					'block-realizations__list-header-button--active',
				);
			}
		} );

		tabContents.forEach( ( item ) => {
			if (
				item.classList.contains(
					'block-realizations__list-galleries-item--active',
				)
			) {
				item.classList.remove(
					'block-realizations__list-galleries-item--active',
				);
			}
		} );

		e.currentTarget.classList.add(
			'block-realizations__list-header-button--active',
		);
		tabContent.classList.add(
			'block-realizations__list-galleries-item--active',
		);
	},
};

window.addEventListener( 'load', () => {
	realizations.init();
} );
